import { IRootState } from '../../reducer';

export const selectIsLogsModalOpen = (rootState: IRootState): boolean => {
  const logsModalSimulationId = rootState.modals.logsModal.simulationId;
  const currentSimulationId = rootState.simulationGroup.simulation && rootState.simulationGroup.simulation.id;

  return !!logsModalSimulationId && !!currentSimulationId && logsModalSimulationId === currentSimulationId;
};
